// extracted by mini-css-extract-plugin
export var box = "_39-0";
export var check = "_39-1";
export var checkboxButton = "_39-6";
export var checkboxGroup = "_39-5";
export var disabled = "_39-7";
export var ghost = "_39-9";
export var input = "_39-2";
export var label = "_39-4";
export var normal = "_39-8";
export var uncheck = "_39-3";